export default "__VITE_ASSET__f7a16a8e__"